import React from 'react';
import styled from 'styled-components';
import { FiBell, FiSearch, FiMenu } from 'react-icons/fi';
import { useAuth } from '../contexts/AuthContext';

const HeaderContainer = styled.header`
  height: 70px;
  background: white;
  border-bottom: 1px solid ${props => props.theme.colors.gray[200]};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${props => props.theme.spacing.xl};
  box-shadow: ${props => props.theme.shadows.sm};
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.lg};
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: ${props => props.theme.fontSizes.xl};
  color: ${props => props.theme.colors.gray[600]};
  cursor: pointer;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    display: block;
  }
`;

const SearchContainer = styled.div`
  position: relative;
  
  input {
    width: 300px;
    padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.md};
    padding-left: 3rem;
    border: 1px solid ${props => props.theme.colors.gray[300]};
    border-radius: ${props => props.theme.borders.radius.md};
    font-size: ${props => props.theme.fontSizes.sm};
    
    &:focus {
      outline: none;
      border-color: ${props => props.theme.colors.primary};
    }
    
    @media (max-width: ${props => props.theme.breakpoints.md}) {
      width: 200px;
    }
  }
  
  svg {
    position: absolute;
    left: ${props => props.theme.spacing.md};
    top: 50%;
    transform: translateY(-50%);
    color: ${props => props.theme.colors.gray[500]};
  }
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.lg};
`;

const NotificationButton = styled.button`
  position: relative;
  background: none;
  border: none;
  font-size: ${props => props.theme.fontSizes.lg};
  color: ${props => props.theme.colors.gray[600]};
  cursor: pointer;
  padding: ${props => props.theme.spacing.sm};
  border-radius: ${props => props.theme.borders.radius.md};
  
  &:hover {
    background: ${props => props.theme.colors.gray[100]};
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 6px;
    right: 6px;
    width: 8px;
    height: 8px;
    background: ${props => props.theme.colors.danger};
    border-radius: 50%;
    border: 2px solid white;
  }
`;

const UserAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${props => props.theme.colors.primary};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  cursor: pointer;
`;

const PageTitle = styled.h1`
  font-size: ${props => props.theme.fontSizes.xl};
  font-weight: 600;
  color: ${props => props.theme.colors.gray[800]};
  margin: 0;
`;

const Header = () => {
  const { user } = useAuth();
  
  const getInitials = (firstName, lastName) => {
    return `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`;
  };

  return (
    <HeaderContainer>
      <LeftSection>
        <MenuButton>
          <FiMenu />
        </MenuButton>
        
        <SearchContainer>
          <FiSearch />
          <input 
            type="text" 
            placeholder="Search..." 
          />
        </SearchContainer>
      </LeftSection>

      <RightSection>
        <NotificationButton>
          <FiBell />
        </NotificationButton>
        
        <UserAvatar>
          {getInitials(user?.firstName, user?.lastName)}
        </UserAvatar>
      </RightSection>
    </HeaderContainer>
  );
};

export default Header;
